// extracted by mini-css-extract-plugin
export default {"loader":"context_loader__OiYXp","rotation":"context_rotation__4GTCJ"};